export default "__VITE_ASSET__afdb77c9__"